import './index.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useBreakpoint } from '@hh.ru/magritte-ui-breakpoint';
import { VSpacing } from '@hh.ru/magritte-ui-spacing';
import { Text } from '@hh.ru/magritte-ui-typography';

const Placeholder = ({ trls, selectFileButton }) => {
    const { isMobile } = useBreakpoint();
    const { title, titleMobile, subTitle } = trls;
    return (jsxs(Fragment, { children: [jsx(Text, { typography: "label-2-regular", children: isMobile ? titleMobile || title : title }), jsx(VSpacing, { default: 6 }), jsx(Text, { typography: "label-4-regular", style: "secondary", children: subTitle }), selectFileButton && (jsxs(Fragment, { children: [jsx(VSpacing, { default: 16 }), selectFileButton] }))] }));
};

export { Placeholder };
//# sourceMappingURL=Placeholder.js.map
